var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnimated = function SvgAnimated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "egOZjhtDyNq1",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 1461 539"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq3-fill",
    x1: 1073.38,
    x2: 1112.87,
    y1: 53.016,
    y2: 78.563,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq3-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq3-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq4-fill",
    x1: 1056.71,
    x2: 1080.75,
    y1: 47.798,
    y2: 51.482,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq4-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq4-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq5-fill",
    x1: 1056.71,
    x2: 1080.75,
    y1: 47.798,
    y2: 51.482,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq5-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq5-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq6-fill",
    x1: 1073.37,
    x2: 1119.47,
    y1: 83.653,
    y2: 106.25,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq6-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq6-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq8-fill",
    x1: 1097.35,
    x2: 1117.93,
    y1: 85.055,
    y2: 95.063,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq8-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq8-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq9-fill",
    x1: 1097.35,
    x2: 1117.93,
    y1: 85.055,
    y2: 95.063,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq9-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq9-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq16-fill",
    x1: 1097.93,
    x2: 1107.56,
    y1: 101.445,
    y2: 113.278,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq16-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq16-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq17-fill",
    x1: 1121.43,
    x2: 1150.03,
    y1: 109.492,
    y2: 119.064,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq17-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq17-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq19-fill",
    x1: 1121.31,
    x2: 1148.21,
    y1: 90.49,
    y2: 110.869,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq19-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq19-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq20-fill",
    x1: 1151.91,
    x2: 1058.48,
    y1: 97.14,
    y2: 83.467,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq20-fill-0",
    offset: "0%",
    stopColor: "#a4d7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq20-fill-1",
    offset: "100%",
    stopColor: "#4fb7fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq22-fill",
    x1: 183.133,
    x2: 91.57,
    y1: 342.763,
    y2: 380.772,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq22-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq22-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq23-fill",
    x1: 219.671,
    x2: 168.432,
    y1: 338.258,
    y2: 336.789,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq23-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq23-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq24-fill",
    x1: 219.671,
    x2: 168.432,
    y1: 338.258,
    y2: 336.789,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq24-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq24-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq25-fill",
    x1: 171.55,
    x2: 67.391,
    y1: 406.297,
    y2: 435.684,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq25-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq25-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq27-fill",
    x1: 121.279,
    x2: 74.812,
    y1: 400.109,
    y2: 413.062,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq27-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq27-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq28-fill",
    x1: 121.279,
    x2: 74.812,
    y1: 400.109,
    y2: 413.062,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq28-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq28-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq35-fill",
    x1: 113.875,
    x2: 89.416,
    y1: 433.882,
    y2: 454.767,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq35-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq35-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq36-fill",
    x1: 62.095,
    x2: -0.839,
    y1: 441.662,
    y2: 450.67,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq36-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq36-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq38-fill",
    x1: 69.552,
    x2: 6.039,
    y1: 402.304,
    y2: 434.364,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq38-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq38-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq39-fill",
    x1: 3.57,
    x2: 202.487,
    y1: 404.496,
    y2: 411.551,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq39-fill-0",
    offset: "0%",
    stopColor: "#a4d7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq39-fill-1",
    offset: "100%",
    stopColor: "#4fb7fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq41-fill",
    x1: 324.793,
    x2: 345.667,
    y1: 55.371,
    y2: 83.558,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq41-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq41-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq42-fill",
    x1: 336.309,
    x2: 324.12,
    y1: 42.138,
    y2: 84.769,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq42-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq42-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq50-fill",
    x1: 358.274,
    x2: 366.386,
    y1: 81.525,
    y2: 95.004,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq50-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq50-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq51-fill",
    x1: 358.274,
    x2: 366.386,
    y1: 81.525,
    y2: 95.004,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq51-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq51-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq52-fill",
    x1: 340.859,
    x2: 338.666,
    y1: 84.418,
    y2: 106.089,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq52-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq52-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq56-fill",
    x1: 277.39,
    x2: 269.121,
    y1: 77.184,
    y2: 113.047,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq56-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq56-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq60-fill",
    x1: 397.497,
    x2: 393.364,
    y1: 45.133,
    y2: 94.637,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq60-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq60-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq61-fill",
    x1: 395.835,
    x2: 410.282,
    y1: 45.024,
    y2: 63.838,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq61-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq61-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq62-fill",
    x1: 318.12,
    x2: 366.922,
    y1: 145.894,
    y2: 27.927,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq62-fill-0",
    offset: "0%",
    stopColor: "#a4d7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq62-fill-1",
    offset: "100%",
    stopColor: "#4fb7fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq67-fill",
    x1: 1405.8,
    x2: 1350.86,
    y1: 430.129,
    y2: 480.364,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq67-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq67-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq68-fill",
    x1: 1357,
    x2: 1259.7,
    y1: 382.313,
    y2: 421.609,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq68-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq68-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq71-fill",
    x1: 1354.51,
    x2: 1321.97,
    y1: 382.503,
    y2: 398.461,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq71-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq71-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq72-fill",
    x1: 1367.27,
    x2: 1355.04,
    y1: 411.156,
    y2: 415.726,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq72-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq72-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq73-fill",
    x1: 1367.27,
    x2: 1355.04,
    y1: 411.156,
    y2: 415.726,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq73-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq73-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq80-fill",
    x1: 1285.53,
    x2: 1240.28,
    y1: 310.934,
    y2: 311.003,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq80-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq80-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq81-fill",
    x1: 1285.53,
    x2: 1240.28,
    y1: 310.934,
    y2: 311.003,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq81-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq81-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq82-fill",
    x1: 1285.53,
    x2: 1240.28,
    y1: 310.934,
    y2: 311.003,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq82-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq82-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq83-fill",
    x1: 1430.19,
    x2: 1372.34,
    y1: 435.391,
    y2: 446.923,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq83-fill-0",
    offset: "0%",
    stopColor: "#0098fb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq83-fill-1",
    offset: "100%",
    stopColor: "#105f93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq85-fill",
    x1: 1239.64,
    x2: 1460.59,
    y1: 384.501,
    y2: 373.99,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq85-fill-0",
    offset: "0%",
    stopColor: "#a4d7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq85-fill-1",
    offset: "100%",
    stopColor: "#4fb7fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egOZjhtDyNq85-stroke",
    x1: 1414.19,
    x2: 1319.79,
    y1: 480.783,
    y2: 333.608,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq85-stroke-0",
    offset: "0%",
    stopColor: "rgba(79,183,251,0)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "egOZjhtDyNq85-stroke-1",
    offset: "100%",
    stopColor: "#bae1ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq3-fill)",
    fillRule: "evenodd",
    d: "m1103.74 51.524-23.54 30.12-6.17 3.154 23.54-30.12z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq4-fill)",
    d: "M1063.28 45.033c-.08.053-.13.17-.11.356l-6.17 3.154c-.02-.185.03-.303.12-.356z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq5-fill)",
    d: "m1069.35 102.854-6.18-57.465-6.17 3.154 6.19 57.465c.05.452.47.813.69.674l6.14-3.139.03-.015-.03.015c-.23.094-.62-.256-.67-.689"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq6-fill)",
    fillRule: "evenodd",
    d: "m1103.79 122.963-23.59-41.32-6.16 3.155 23.59 41.319zm.56.331c-.16.082-.4-.061-.56-.331l-6.16 3.154c.15.27.4.413.56.331z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1104.35 123.295c.01-.004.02-.008.02-.012l-6.16 3.154c-.01.004-.01.008-.02.012z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq8-fill)",
    d: "M1103.82 84.174c.18-.086.47.109.61.443l-6.17 3.154c-.14-.334-.43-.53-.61-.444z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq9-fill)",
    d: "m1111.08 100.516-6.65-15.899-6.17 3.154 6.65 15.899c.11.254.09.501-.05.592l6.17-3.154c.13-.091.15-.338.05-.592"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1103.82 84.173a.2.2 0 0 0-.08.065l-6.17 3.154c.03-.03.05-.051.08-.065z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "m1103.74 84.238-6.65 8.6-6.17 3.153 6.65-8.599z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1097.08 92.837c-.1.137-.08.408.06.65l-6.17 3.153c-.13-.241-.15-.512-.05-.65z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "m1097.14 93.486 6.65 11.707-6.16 3.154-6.66-11.707z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1103.79 105.193c.15.267.39.41.55.338l-6.16 3.154c-.16.072-.4-.071-.55-.338z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1104.34 105.531q.015-.007.03-.016l-6.16 3.154q-.015.01-.03.016z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq16-fill)",
    fillRule: "evenodd",
    d: "m1104.37 105.514 6.66-4.408-6.17 3.154-6.65 4.408z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq17-fill)",
    d: "m1138.03 140.672-10.07-32.817-6.16 3.154 10.06 32.817c.12.395.45.616.64.536l6.17-3.154c-.2.08-.52-.141-.64-.536"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1144.34 89.467a.3.3 0 0 0-.09.06l-6.16 3.154a.2.2 0 0 1 .08-.06z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq19-fill)",
    fillRule: "evenodd",
    d: "m1144.25 89.527-16.29 18.329-6.16 3.154 16.29-18.329z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq20-fill)",
    fillRule: "evenodd",
    d: "m1127.96 107.855-23.53-55.953c-.17-.387-.53-.586-.69-.378l-23.54 30.12 23.59 41.319c.16.281.42.425.58.32zm-16.93-6.748c.13-.091.15-.338.05-.592l-6.65-15.899c-.17-.388-.53-.589-.69-.379l-6.66 8.6c-.1.137-.08.408.06.649l6.65 11.707c.16.284.42.428.58.321zm16.93 6.748 10.07 32.817c.17.549.73.762.78.298l6.19-50.678c.05-.48-.5-1.047-.75-.765zm-47.76-26.212-10.06 21.774c-.17.365-.73-.038-.79-.564l-6.18-57.465c-.06-.544.49-.506.74.051z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq22-fill)",
    fillRule: "evenodd",
    d: "m120.749 328.166 37.396 71.375 11.585 8.875-37.396-71.375z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq23-fill)",
    d: "M207.093 330.036c.157.142.217.405.105.782l11.585 8.875c.111-.376.051-.64-.105-.782z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq24-fill)",
    d: "m172.599 447.631 34.599-116.813 11.585 8.875-34.599 116.814c-.272.919-1.282 1.508-1.694 1.134l-11.53-8.833-.055-.042.055.042c.44.282 1.379-.296 1.639-1.177"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq25-fill)",
    fillRule: "evenodd",
    d: "m93.568 476.278 64.577-76.737 11.585 8.876-64.578 76.737h-.001c-.423.502-.988.704-1.293.473l-11.585-8.876c.305.232.87.029 1.294-.473",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "m92.275 476.751-.037-.032 11.585 8.876.037.031z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq27-fill)",
    d: "M108.215 395.833c-.344-.246-1.018.048-1.435.688l11.584 8.876c.417-.64 1.092-.935 1.436-.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq28-fill)",
    d: "m86.963 426.969 19.817-30.448 11.584 8.876-19.817 30.447c-.317.487-.365 1.007-.115 1.246l-11.585-8.875c-.25-.24-.201-.76.116-1.246"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M108.214 395.833q.085.06.14.164l11.584 8.875a.46.46 0 0 0-.139-.164zM108.352 395.999l10.534 20.352 11.584 8.875-10.533-20.351z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M118.887 416.351c.168.325.02.878-.355 1.326l11.584 8.876c.375-.448.524-1.001.355-1.327z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "m118.532 417.677-18.229 21.755 11.584 8.875 18.229-21.754z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M100.304 439.431c-.416.496-.97.701-1.279.49l11.585 8.875c.309.212.863.006 1.278-.489z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M99.026 439.92a.4.4 0 0 1-.056-.045l11.584 8.875a1 1 0 0 0 .057.046z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq35-fill)",
    fillRule: "evenodd",
    d: "m98.968 439.875-12.122-11.659 11.584 8.876 12.122 11.659z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq36-fill)",
    d: "m15.864 500.026 33.3-64.235 11.585 8.876-33.3 64.234c-.401.774-1.158 1.109-1.528.869l-11.585-8.876c.37.24 1.127-.095 1.528-.868"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M22.189 391.458a.5.5 0 0 1 .15.156l11.585 8.876a.5.5 0 0 0-.15-.156z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq38-fill)",
    fillRule: "evenodd",
    d: "m22.337 391.612 26.827 44.178 11.585 8.876-26.827-44.178z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq39-fill)",
    fillRule: "evenodd",
    d: "m49.164 435.79 70.014-107.103c.484-.741 1.313-1.016 1.571-.523l37.396 71.376-64.577 76.737c-.441.523-1.037.721-1.331.443zm37.683-7.575c-.25-.24-.202-.759.115-1.246l19.817-30.447c.484-.744 1.317-1.021 1.575-.524l10.533 20.352c.169.325.02.878-.355 1.326l-18.229 21.755c-.441.527-1.04.726-1.334.444zm-37.683 7.575-33.3 64.235c-.557 1.074-1.8 1.302-1.741.319l6.383-107.428c.06-1.018 1.417-1.984 1.83-1.304zm108.981-36.25 12.613 48.962c.21.819 1.525.197 1.842-.872l34.598-116.814c.328-1.106-.829-1.237-1.56-.175z",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq41-fill)",
    d: "M325.625 64.794c-.413-.106-.982.086-1.078.365l-13.913 40.371-1.321-8.452 13.914-40.371c.096-.28.664-.471 1.078-.365z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq42-fill)",
    fillRule: "evenodd",
    d: "m325.625 64.793 59.792 15.415-1.32-8.452-59.792-15.415z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M363.605 111.104c-.149.211-.558.349-.913.309l-1.32-8.452c.355.04.764-.098.913-.309zM338.088 97.933a.2.2 0 0 1 .01-.106l-1.32-8.452a.2.2 0 0 0-.01.106z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "m338.097 97.828 3.884-11.465-1.32-8.452-3.884 11.465zM341.982 86.363c.095-.28.667-.474 1.081-.366l-1.32-8.452c-.415-.108-.986.085-1.081.366z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "m343.063 85.998 16.942 4.413-1.32-8.452-16.942-4.413zM360.005 90.41c.174.044.278.134.298.24l-1.32-8.452c-.02-.106-.125-.196-.298-.24z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M360.303 90.65a.25.25 0 0 1-.05.19l-1.32-8.453a.25.25 0 0 0 .049-.189z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq50-fill)",
    d: "M353.218 99.897c.357.041.768-.098.916-.31l-1.321-8.452c-.148.212-.559.351-.915.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq51-fill)",
    d: "m354.134 99.587 6.119-8.748-1.32-8.452-6.12 8.748z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq52-fill)",
    d: "M338.088 97.933c.021.135.18.24.423.268l14.707 1.696-1.32-8.452-14.708-1.696c-.242-.028-.401-.133-.423-.268z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M309.429 128.554c-.02.385-.948.621-1.3.33l-1.32-8.452c.352.291 1.28.055 1.3-.33zM308.128 128.884l-38.501-31.767-1.321-8.452 38.502 31.767z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M269.627 97.117a.25.25 0 0 1-.092-.134l-1.321-8.452a.26.26 0 0 0 .093.134z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq56-fill)",
    fillRule: "evenodd",
    d: "M269.533 96.983a.1.1 0 0 1-.005-.035zm1.065-.492c-.508-.114-1.087.181-1.07.457l-1.315-8.417c-.072-.285.535-.611 1.066-.491l40.031 9.038 1.321 8.452z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "m385.416 80.21 30.301 12.356-1.32-8.452-30.301-12.357zM415.717 92.565c.466.19 1.203-.098 1.182-.418l-1.32-8.452c.021.32-.716.608-1.182.418z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M416.899 92.147a.2.2 0 0 0-.023-.084l-1.32-8.452a.2.2 0 0 1 .023.084z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq60-fill)",
    fillRule: "evenodd",
    d: "m396.417 45.29 19.14 38.322 1.32 8.452-19.14-38.323v-.001c-.183-.362-1.184-.241-1.353.163l-1.32-8.452c.168-.405 1.172-.525 1.353-.162z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq61-fill)",
    fillRule: "evenodd",
    d: "M396.383 53.903 385.417 80.21l-1.32-8.452 10.966-26.306z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq62-fill)",
    fillRule: "evenodd",
    d: "m310.633 105.532 13.914-40.371c.096-.28.664-.472 1.077-.365l59.792 15.415-21.812 30.895c-.149.211-.558.349-.913.309zm27.877-7.33c-.303-.034-.475-.19-.412-.373l3.884-11.465c.095-.28.667-.474 1.081-.366l16.942 4.413c.271.07.374.25.248.43l-6.119 8.748c-.148.212-.559.351-.916.31zm-27.877 7.33-1.204 23.024c-.02.385-.948.621-1.301.33l-38.501-31.767c-.365-.301.356-.765.973-.626zm74.783-25.321 30.301 12.357c.507.207 1.334-.152 1.159-.502l-19.14-38.324c-.182-.363-1.185-.242-1.354.163z",
    clipRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "m1299.61 369.398 63.41-42.12-9.21 7.871-63.41 42.119zM1363.02 327.282c.44-.291 1.23.156 1.51.849l-9.21 7.87c-.27-.693-1.07-1.14-1.51-.849z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "m1364.53 328.13 40.15 100.16-9.21 7.871L1355.33 336z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq67-fill)",
    fillRule: "evenodd",
    d: "m1404.68 428.29-59.56 17.816-9.21 7.87 59.56-17.816z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq68-fill)",
    fillRule: "evenodd",
    d: "M1334.63 453.258c.3.517.87.838 1.28.718l9.21-7.871c-.41.121-.98-.2-1.29-.719l-44.22-75.985-9.21 7.871z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1336.18 394.495c-.24-.417-.23-.843.01-1.053l-9.21 7.87c-.24.21-.25.636-.01 1.053z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1336.19 393.441c.01-.014.03-.026.04-.038l-9.2 7.871a.2.2 0 0 0-.05.037z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq71-fill)",
    fillRule: "evenodd",
    d: "m1336.23 393.403 17.94-12.048-9.2 7.871-17.94 12.047z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq72-fill)",
    d: "M1354.17 381.356c.44-.294 1.25.156 1.52.852l11.32 28.447-9.21 7.871-11.32-28.448c-.27-.696-1.08-1.146-1.51-.851z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq73-fill)",
    d: "M1366.92 411.506c.19-.174.23-.496.09-.851l-9.21 7.871c.14.354.1.676-.09.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1366.93 411.506a.54.54 0 0 1-.2.11l-9.21 7.87a.54.54 0 0 0 .2-.11zM1366.73 411.615l-16.81 5.118-9.21 7.87 16.81-5.118z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1349.92 416.736c-.4.124-.98-.2-1.28-.721l-9.21 7.87c.3.522.88.845 1.28.721zM1348.64 416.012l-12.46-21.518-9.21 7.87 12.46 21.519zM1299.61 369.4l-29.51 32.715-9.21 7.87 29.51-32.714z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "m1270.1 402.112-.03.031-9.21 7.871.03-.031z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq80-fill)",
    d: "M1269.59 303.48c-.1.094-.17.24-.17.442l-9.21 7.87c.01-.202.07-.348.17-.442z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq81-fill)",
    d: "m1268.41 400.927 1.01-97.005-9.21 7.87-1.01 97.004c-.01.87 1.15 1.702 1.66 1.22l9.17-7.837c-.53.407-1.63-.404-1.62-1.252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq82-fill)",
    d: "M1270.07 402.146c-.01.012-.03.023-.04.033z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq83-fill)",
    d: "m1419.43 485.814-14.75-57.524-9.21 7.87 14.75 57.524c.21.827 1.18 1.338 1.6.989l9.21-7.871c-.43.349-1.39-.161-1.6-.988"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580e1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1449.41 404.806c.27-.775-.87-1.891-1.54-1.506l-9.21 7.87c.67-.385 1.81.731 1.54 1.506z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#egOZjhtDyNq85-fill)",
    stroke: "url(#egOZjhtDyNq85-stroke)",
    d: "m1299 369.333-.06-.092.05-.028-28.29-64.767c-.16-.361-.46-.555-.66-.593a.3.3 0 0 0-.11-.004c0 .013-.01.036-.01.075l-1.01 97.005c0 .227.17.523.45.718.13.092.24.13.31.137h.03c.02 0 .02-.002.03-.003v-.004zm-29.06-65.498v.005zm134.07 124.13-39.94-99.653a1.1 1.1 0 0 0-.48-.543.54.54 0 0 0-.23-.081c-.03-.002-.04 0-.05.002s-.01.004-.01.004l-63.02 41.859 43.99 75.579c.1.182.26.329.41.415.16.091.27.085.3.076zm1.29.538.05.106-.07.019 14.64 57.059-.49.124.49-.124c.08.313.33.572.59.679.11.049.18.048.21.043v-.013l28.22-81.758c.02-.052.02-.141-.03-.274a1.1 1.1 0 0 0-.27-.393.9.9 0 0 0-.36-.235c-.1-.034-.15-.014-.16-.008zm-51.4-47.565c.44-.3.98-.17 1.34.033.38.215.74.587.92 1.048l11.32 28.448c.12.303.16.634.07.938a1 1 0 0 1-.67.686l-16.81 5.118c-.38.115-.77.009-1.08-.161-.31-.175-.59-.45-.79-.788l-12.45-21.519a1.6 1.6 0 0 1-.24-.913c.01-.313.14-.639.45-.843z"
  }))));
};
export default SvgAnimated;